<template>
  <NuxtLayout :name="layout">
    <div class="flex flex-col items-center justify-center">
      <h1 class="text-6xl font-bold">{{ error!.statusCode }}</h1>
      <p v-if="showErrorMessage" class="text-2xl font-bold">
        {{ errorMessage }}
      </p>
      <template v-if="!environment('production')">
        <div class="p-4">
          <pre class="whitespace-pre-wrap">{{
            JSON.stringify(
              JSON.parse((error?.data ?? "{}").toString()),
              null,
              4,
            )
          }}</pre>
        </div>
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = withDefaults(
  defineProps<{
    error?: NuxtError
    layout?: any
  }>(),
  {
    layout: 'default',
  },
)

const { t } = useI18n()

const showErrorMessage = computed(
  () =>
    !environment('production') || [403, 404].includes(props.error!.statusCode),
)

const errorMessage = computed(() => {
  switch (props.error!.statusCode) {
    case 403:
      return t('errors.403')
    case 404:
      return t('errors.404')
    default:
      return props.error!.message
  }
})
</script>
